import USER_ROLES from './userRoles';

// Interrupteurs de fonctionnalités : permettent de couper une fonctionnalité livrée sans la
// retirer du code, le temps qu'une dépendance externe soit prête ou qu'une décision produit
// tombe. Un drapeau à `false` doit rendre la fonctionnalité TOTALEMENT inatteignable — aucun
// point d'entrée visible, aucun appel réseau.
//
// Pour retirer un drapeau : le passer à `true`, vérifier, puis supprimer le drapeau ET ses
// points d'accroche (`grep -rn "FEATURES" src/` les liste tous).
export const FEATURES = {
    // Mode incognito (Voissa Premium / Admin) — désactivé sur demande produit.
    //
    // Requiert côté API, avant toute réactivation : la capability `canUseIncognito`, la route
    // `PATCH /users/me/set-toggle-incognito`, `incognitoTotal` sur les vues de story et la part
    // `incognito` des statistiques. Ces éléments vivent sur `develop` et ne sont pas déployés.
    //
    // À `false` : le sélecteur du menu disparaît, l'indicateur de la barre de navigation aussi,
    // l'incognito n'est plus vendu dans les offres, et les décomptes (stats, vues de story)
    // repassent au partage membres / invités d'origine.
    INCOGNITO: true,

    // Affichage des niveaux aux membres (badge, bulle, page « Mon niveau », page publique).
    //
    // OUVERT À TOUS depuis le 04/11/2026, sur décision de Bertrand. Il a vécu fermé le temps de
    // juger le rendu sur de vraies données, et c'était le seul drapeau de ce fichier qui laissait
    // passer quelqu'un à `false` : les administrateurs voyaient l'affichage, les membres non.
    //
    // IL RESTE EN PLACE le temps de vérifier l'ouverture en production — il referme tout en une
    // ligne. Une fois l'ouverture acquise, le supprimer AVEC ses points d'accroche :
    // `grep -rn "canSeeLevelDisplay" src/` les liste tous.
    // Tant qu'il vit, ne jamais le lire directement pour décider d'un affichage : passer par
    // `canSeeLevelDisplay(currentUser)` ci-dessous, pour qu'un retour à `false` laisse la vue aux
    // administrateurs.
    //
    // Il ne remplace PAS le verrou métier. Même ouvert, le badge n'apparaît que si l'API le rend :
    // certification en cours de validité et aucune sanction globale en cours (services/credit/xp.js
    // côté API). Ce drapeau ne règle que le déploiement.
    LEVEL_DISPLAY: true,
};

/**
 * L'affichage des niveaux est-il visible pour CE visiteur ?
 *
 * Une fonction et non le seul drapeau, parce que la réponse dépend de qui regarde. Elle vit ici,
 * à côté de son drapeau, pour que le retrait reste une seule suppression le jour de l'ouverture.
 *
 * @param {object} currentUser — le membre connecté (`useCurrentUser()`), ou rien pour un visiteur
 */
export const canSeeLevelDisplay = (currentUser) => FEATURES.LEVEL_DISPLAY
    || currentUser?.role === USER_ROLES.ADMINISTRATOR;

export default FEATURES;
